export default __webpack_public_path__ + "static/media/javascript_icon_130900 (1).621f6061.png";